export default {
  business: state => state.business,
  devices: state => state.devices
}
